import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      // Mantém o cache por 5 min após a query ficar inativa — voltar pra uma aba
      // já visitada pinta na hora (sem spinner) e revalida em background.
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
    },
  },
});
